import React from 'react';
import PowerBIReport from './PowerBIReport';
import { IFilter, IBasicFilter, IAdvancedFilter } from 'powerbi-models';
import moment from 'moment';
import { models } from 'powerbi-client';
import CallTableViewModel from '../ViewModels/CallTableViewModel';

interface IReportContainer {
    todayReportId: string;
    historicReportId: string;
    filters: CallTableViewModel;
    isAgentView?: boolean;
    isSelected: boolean
}
export default function ReportContainer(props: IReportContainer) {
    const [iFilters, setIFilters] = React.useState<IFilter[]>([]);

    React.useEffect(() => {
        generatePowerBIFilters(props.filters.filters.salesAI.question, props.filters.filters.salesAI.channel)
    }, [props.filters]);

    const createFilter = (flag: boolean, table: string, column: string, operator: "In" | "NotIn" | "All", value: (string | number | boolean)[]) => {
        if (flag && value.length == 0) {
            let filter: IAdvancedFilter = {
                $schema: "http://powerbi.com/product/schema#advanced",
                target: {
                    table: table,
                    column: column,
                },

                logicalOperator: "And",
                conditions: [{ operator: "IsNotBlank" }],
                filterType: models.FilterType.Advanced
            }
            return filter;
        }

        if (flag && value.length > 0) {
            let filter: IBasicFilter = {
                $schema: "http://powerbi.com/product/schema#basic",
                target: {
                    table: table,
                    column: column
                },

                operator: operator,
                values: value,
                filterType: models.FilterType.Basic
            };
            return filter;
        }

        let filter: IBasicFilter = {
            $schema: "http://powerbi.com/product/schema#basic",
            target: {
                table: table,
                column: column
            },
            operator: "All",
            values: [],
            filterType: models.FilterType.Basic
        };

        return filter;
    }

    const getWeekdayIndex = (day) => {
        //returns day index with monday as the default.
        const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
        return days.indexOf(day) !== -1 ? days.indexOf(day) : 1;
    };

    const generatePowerBIFilters = (questionText: string, templateChannel: string) => {
        let pbiFilters: IFilter[] = [];
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.dateTimeFilters.preset == 'today', 'KeyStone_DimDate', 'Today', "In", ["Today"]));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.dateTimeFilters.preset == 'Yesterday', 'KeyStone_DimDate', 'Yesterday', "In", ["Yesterday"]));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.dateTimeFilters.preset == 'This Month', 'KeyStone_DimDate', 'MTD', "In", ["MTD"]));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.dateTimeFilters.preset == 'Last Month', 'KeyStone_DimDate', 'LastMonth', "In", ["LastMonth"]));

        if (props.filters.filters.dateTimeFilters.preset == "Single Date") {
            const date = moment(props.filters.filters.dateTimeFilters.startDate).format("DD MMM YYYY");
            let singleDate: IBasicFilter = {
                $schema: "http://powerbi.com/product/schema#basic",
                target: {
                    table: 'KeyStone_DimDate',
                    column: 'Calendar Date',
                },

                operator: "In",
                values: [date],
                filterType: models.FilterType.Basic
            };
            pbiFilters = pbiFilters.concat(singleDate);
        }

        if (props.filters.filters.dateTimeFilters.preset == "Date Range") {
            const startDate = moment(props.filters.filters.dateTimeFilters.startDate);
            const endDate = moment(props.filters.filters.dateTimeFilters.endDate);

            let dateArray: string[] = [];
            let checkDate = startDate.clone();

            const diff = endDate.diff(checkDate, "days");
            for (var i = 0; i <= diff; i++) {
                dateArray.push(checkDate.format("DD MMM YYYY"));
                checkDate.add(1, "day");
            }
            let dateRange: IBasicFilter = {
                $schema: "http://powerbi.com/product/schema#basic",
                target: {
                    table: 'KeyStone_DimDate',
                    column: 'Calendar Date',
                },

                operator: "In",
                values: dateArray,
                filterType: models.FilterType.Basic
            };
            pbiFilters = pbiFilters.concat(dateRange);
        }

        if (props.filters.filters.dateTimeFilters.preset == "This Week") {
            const startDate = moment();
            const endDate = moment();
            let weekday = getWeekdayIndex(props.filters.filters.dateTimeFilters.dayOfWeek);

            while (startDate.weekday() !== weekday) {
                startDate.subtract(1, "day")
            }

            let dateArray: string[] = [];
            let checkDate = startDate.clone();

            const diff = endDate.diff(checkDate, "days");
            for (var i = 0; i <= diff; i++) {
                dateArray.push(checkDate.format("DD MMM YYYY"));
                checkDate.add(1, "day");
            }

            let thisWeek: IBasicFilter = {
                $schema: "http://powerbi.com/product/schema#basic",
                target: {
                    table: 'KeyStone_DimDate',
                    column: 'Calendar Date',
                },

                operator: "In",
                values: dateArray,
                filterType: models.FilterType.Basic
            };

            pbiFilters = pbiFilters.concat(thisWeek);
        }

        if (props.filters.filters.dateTimeFilters.preset == "Last Week") {
            let startDate = moment();
            let endDate = moment();
            let weekday = getWeekdayIndex(props.filters.filters.dateTimeFilters.dayOfWeek);
           

            if (weekday > endDate.weekday()) {
                while (startDate.weekday() !== weekday) {
                    startDate.subtract(1, "day");
                }
                endDate = startDate.clone().subtract(1,"day");
                startDate.subtract(7, "day");
            }
            else {

                while (endDate.weekday() !== weekday) {
                    endDate.subtract(1, "day")
                }
                startDate = endDate.clone().subtract(7, "day");
            }
            let dateArray: string[] = [];
            let checkDate = startDate.clone();

            const diff = endDate.diff(checkDate, "days");
            for (var i = 0; i <= diff; i++) {
                dateArray.push(checkDate.format("DD MMM YYYY"));
                checkDate.add(1, "day");
            }
            let lastWeek: IBasicFilter = {
                $schema: "http://powerbi.com/product/schema#basic",
                target: {
                    table: 'KeyStone_DimDate',
                    column: 'Calendar Date',
                },

                operator: "In",
                values: dateArray,
                filterType: models.FilterType.Basic
            };

            pbiFilters = pbiFilters.concat(lastWeek);
        }

        if (!(props.filters.filters.dateTimeFilters.preset == "Last Week") && !(props.filters.filters.dateTimeFilters.preset == "This Week") && !(props.filters.filters.dateTimeFilters.preset == "Date Range") && !(props.filters.filters.dateTimeFilters.preset == "Single Date")) {
            let noDate: IBasicFilter = {
                $schema: "http://powerbi.com/product/schema#basic",
                target: {
                    table: 'KeyStone_DimDate',
                    column: 'Calendar Date',
                },

                operator: "All",
                values: [],
                filterType: models.FilterType.Basic
            };
            pbiFilters = pbiFilters.concat(noDate);
        }

        if (props.filters.filters.dateTimeFilters.flagTimeRange) {
            let timeRange: IAdvancedFilter = {
                $schema: "http://powerbi.com/product/schema#advanced",
                target: {
                    table: 'KeyStone_DimTime',
                    column: 'Full_Time',
                },

                logicalOperator: "And",
                conditions: [{ operator: "GreaterThanOrEqual", value: props.filters.filters.dateTimeFilters.startTime }, { operator: "LessThanOrEqual", value: props.filters.filters.dateTimeFilters.endTime }],
                filterType: models.FilterType.Advanced
            };
            pbiFilters = pbiFilters.concat(timeRange);
        }
        else {
            let timeRange: IBasicFilter = {
                $schema: "http://powerbi.com/product/schema#basic",
                target: {
                    table: 'KeyStone_DimTime',
                    column: 'Full_Time',
                },
                operator: "All",
                values: [],
                filterType: models.FilterType.Basic
            }
            pbiFilters = pbiFilters.concat(timeRange);

            if (props.filters.filters.callFilters.isCallLengthFlag) {
                if (props.filters.filters.callFilters.callLengthMax === 606) {
                    let CallLengthRange: IAdvancedFilter = {
                        $schema: "http://powerbi.com/product/schema#advanced",
                        target: {
                            table: 'KeyStone_ResQ_FactSystem_View',
                            column: 'Talk_Time',
                        },

                        logicalOperator: "And",
                        conditions: [{ operator: "GreaterThanOrEqual", value: props.filters.filters.callFilters.callLengthMin }],
                        filterType: models.FilterType.Advanced
                    };
                    pbiFilters = pbiFilters.concat(CallLengthRange);
                }
                else {
                    let CallLengthRange: IAdvancedFilter = {
                        $schema: "http://powerbi.com/product/schema#advanced",
                        target: {
                            table: 'KeyStone_ResQ_FactSystem_View',
                            column: 'Talk_Time',
                        },

                        logicalOperator: "And",
                        conditions: [{ operator: "GreaterThanOrEqual", value: props.filters.filters.callFilters.callLengthMin }, { operator: "LessThanOrEqual", value: props.filters.filters.callFilters.callLengthMax }],
                        filterType: models.FilterType.Advanced
                    };
                    pbiFilters = pbiFilters.concat(CallLengthRange);
                }
            }
            else {
                let CallLengthRange: IBasicFilter = {
                    $schema: "http://powerbi.com/product/schema#basic",
                    target: {
                        table: 'KeyStone_ResQ_FactSystem_View',
                        column: 'Talk_Time',
                    },

                    operator: "All",
                    values: [],
                    filterType: models.FilterType.Basic
                };

                pbiFilters = pbiFilters.concat(CallLengthRange);
            }
        }
        //Client filters should always be on
        pbiFilters = pbiFilters.concat(createFilter(true, 'KeyStone_ResQ_DimTeam', 'Client', "In", [props.filters.filters.client!]));
        pbiFilters = pbiFilters.concat(createFilter(true, 'FlagStone_FactSummaries', 'Client', "In", [props.filters.filters.client!]));


        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.operationsFilters.site.length > 0, 'KeyStone_ResQ_DimTeam', 'HomeSite', "In", props.filters.filters.operationsFilters.site));

        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.salesFilters.isActive, 'KeyStone_ResQ_FactSystem_View', 'Saless', "In", [(props.filters.filters.salesFilters.sale ? 1 : 0)]));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.callFilters.result.length > 0, 'KeyStone_ResQ_FactSystem_View', 'Result', props.filters.filters.callFilters.resultExclude ? "NotIn" : "In", props.filters.filters.callFilters.result!));

        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.callFilters.resultSource != "" && props.filters.filters.callFilters.resultSource != null, 'KeyStone_ResQ_FactSystem_View', 'ResultSource', "In", [props.filters.filters.callFilters.resultSource!]));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.customerFilters.customerID != "", 'KeyStone_ResQ_FactSystem_View', 'CustomerID', "In", [props.filters.filters.customerFilters.customerID!]));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.customerFilters.telephone != "", 'KeyStone_ResQ_FactSystem_View', 'Telephone', "In", [props.filters.filters.customerFilters.telephone!]));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.customerFilters.clientRef != "", 'KeyStone_ResQ_FactSystem_View', 'ClientRef', "In", [props.filters.filters.customerFilters.clientRef!]));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.vulnerabilitiesFilters.vulnerability.length > 0, 'FlagStone_DimVulnerability', 'Value', "In", props.filters.filters.vulnerabilitiesFilters.vulnerability));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.complaintsFilters.complaint.length > 0, 'FlagStone_DimComplaints', 'Value', "In", props.filters.filters.complaintsFilters.complaint));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.vulnerabilitiesFilters.vulnerabilityCategory.length > 0, 'FlagStone_DimVulnerability', 'ValueCategory', "In", props.filters.filters.vulnerabilitiesFilters.vulnerabilityCategory));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.complaintsFilters.complaintCategory.length > 0, 'FlagStone_DimComplaints', 'ValueCategory', "In", props.filters.filters.complaintsFilters.complaintCategory));


        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.reportCodeFilters.reportCode1.values.length > 0, 'KeyStone_ResQ_FactSystem_View', 'ReportCode1Description', props.filters.filters.reportCodeFilters.reportCode1.excluded ? "NotIn" : "In", props.filters.filters.reportCodeFilters.reportCode1.values));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.reportCodeFilters.reportCode2.values.length > 0, 'KeyStone_ResQ_FactSystem_View', 'ReportCode2Description', props.filters.filters.reportCodeFilters.reportCode2.excluded ? "NotIn" : "In", props.filters.filters.reportCodeFilters.reportCode2.values));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.reportCodeFilters.reportCode3.values.length > 0, 'KeyStone_ResQ_FactSystem_View', 'ReportCode3Description', props.filters.filters.reportCodeFilters.reportCode3.excluded ? "NotIn" : "In", props.filters.filters.reportCodeFilters.reportCode3.values));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.reportCodeFilters.reportCode5.values.length > 0, 'KeyStone_ResQ_FactSystem_View', 'ReportCode5Description', props.filters.filters.reportCodeFilters.reportCode5.excluded ? "NotIn" : "In", props.filters.filters.reportCodeFilters.reportCode5.values));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.callFilters.systemID != "", 'KeyStone_ResQ_FactSystem_View', 'SystemID', "In", [props.filters.filters.callFilters.systemID!]));


        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.operationsFilters.agentName.length > 0, 'KeyStone_ResQ_DimTeam', 'PayrollNumber', "In", props.filters.filters.operationsFilters.agentName.map(m => m.payrollNumber.toString())));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.operationsFilters.agentName.length > 0, 'FlagStone_FactSummaries', 'UserName', "In", props.filters.filters.operationsFilters.agentName.map(m => m.name.replace('@resqcs.co.uk', ''))));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.operationsFilters.teamLeader.length > 0, 'KeyStone_ResQ_DimOperations', 'Team Leader', "In", props.filters.filters.operationsFilters.teamLeader.map(m => m.replace('@resqcs.co.uk', ''))));

        //  pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.sentimentFilters.sen, 'FlagStone_DimSentiment', 'Sentiment Level - Customer', "In", props.filters.filters.customerSentimentEnd));

        //  pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.flagAgentSentimentEnd, 'FlagStone_DimSentiment', 'Sentiment Level - Agent', "In", props.filters.filters.agentSentimentEnd));

        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.qaFilters.monitoringStatus == "Completed", 'KeyStone_ResQ_DimQADetails', 'Complete', "In", [true]));

        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.qaFilters.monitoredBy.length > 0, 'KeyStone_ResQ_DimQADetails', 'QA', "In", props.filters.filters.qaFilters.monitoredBy));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.qaFilters.monitoringResult !== "", 'KeyStone_ResQ_DimQADetails', 'QA Result', "In", [props.filters.filters.qaFilters.monitoringResult]));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.qaFilters.monitoringResqResult !== "", 'KeyStone_ResQ_DimQADetails', 'QA ResQResult', "In", [props.filters.filters.qaFilters.monitoringResqResult]));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.operationsFilters.team.length > 0, 'KeyStone_ResQ_DimTeam', 'Team', "In", props.filters.filters.operationsFilters.team));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.salesFilters.productReference !== "", 'KeyStone_ResQ_FactProduct_View', 'ClientRef', "In", [props.filters.filters.salesFilters.productReference]));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.salesFilters.saleType.length > 0, 'KeyStone_ResQ_FactProduct_View', 'SaleType', "In", props.filters.filters.salesFilters.saleType));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.salesFilters.productType.length > 0, 'KeyStone_ResQ_FactProduct_View', 'ProductType', "In", props.filters.filters.salesFilters.productType));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.salesFilters.product.length > 0, 'KeyStone_ResQ_FactProduct_View', 'Product', "In", props.filters.filters.salesFilters.product));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.salesFilters.productOffer.length > 0, 'KeyStone_ResQ_FactProduct_View', 'ProductOffer', "In", props.filters.filters.salesFilters.productOffer));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.qaFilters.alert != "", 'KeyStone_ResQ_DimQADetails', 'AnswerLabel', "In", [props.filters.filters.qaFilters.alert]));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.qaFilters.alert != "", 'KeyStone_ResQ_DimQADetails', 'QuestionText', "In", ["Alert Level"]));

        //not sure if props.filters.filters.salesAI.answer != "" is the right switch here
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.salesAI.answer != "", 'FlagStone_AI_View', 'Question', "In", [questionText]));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.salesAI.answer != "", 'FlagStone_AI_View', 'Value', "In", [props.filters.filters.salesAI.answer]));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.salesAI.answer != "", 'KeyStone_ResQ_DimTeam', 'Channel', "In", [templateChannel]));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.salesAI.answer != "", 'FlagStone_FactSummaries', 'Channel', "In", [templateChannel]));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.operationsFilters.channel.length > 0, 'KeyStone_ResQ_DimTeam', 'Channel', "In", props.filters.filters.operationsFilters.channel));
        pbiFilters = pbiFilters.concat(createFilter(props.filters.filters.operationsFilters.channel.length > 0, 'FlagStone_FactSummaries', 'Channel', "In", props.filters.filters.operationsFilters.channel));
        //IDK what the below does?

        //if (!props.filters.filters.flagChannel && !props.filters.filters.flagSalesAI) {
        //    let channel1: IBasicFilter = {
        //        $schema: "http://powerbi.com/product/schema#basic",
        //        target: {
        //            table: 'KeyStone_ResQ_DimTeam',
        //            column: 'Channel',
        //        },

        //        operator: "All",
        //        values: [],
        //        filterType: models.FilterType.Basic
        //    };
        //    pbiFilters = pbiFilters.concat(channel1);

        //    let channel2: IBasicFilter = {
        //        $schema: "http://powerbi.com/product/schema#basic",
        //        target: {
        //            table: 'FlagStone_FactSummaries',
        //            column: 'Channel',
        //        },

        //        operator: "All",
        //        values: [],
        //        filterType: models.FilterType.Basic
        //    };

        //    pbiFilters = pbiFilters.concat(channel2);
        //}
        setIFilters(pbiFilters);

    }
    return (
        < PowerBIReport reportId={props.filters.filters.dateTimeFilters.preset == "Today" ? props.todayReportId : props.historicReportId} iFilters={iFilters} isAgentView={props.isAgentView} enableRefresh={props.filters.filters.dateTimeFilters.preset == "Today" && props.isSelected} isSelected={props.isSelected} />
    );
}
